import { Component, OnInit } from '@angular/core';
import { AuthenticationService, Logger } from '@app/core';
import { identityServerAngularConfig } from '@env/environment';
import { UserManager, WebStorageStateStore } from 'oidc-client-ts';
import { LoaderService } from '@app/core/loader.service';
import { Router } from '@angular/router';
import { AuthServiceCleaner } from '@shared/services/auth.service.cleaner';
const log = new Logger('ResetLoginComponent');

@Component({
  selector: 'app-reset-login',
  templateUrl: './reset-login.component.html',
  styleUrls: ['./reset-login.component.sass'],
})
export class ResetLoginComponent implements OnInit {
  constructor(
    private loaderService: LoaderService,
    private authService: AuthenticationService,
    private authClearService: AuthServiceCleaner,
    private router: Router
  ) {}

  ngOnInit() {
    this.loaderService.showMain = false;
    if (this.authService.getUser()) {
      this.authService.getCurrentUser().subscribe({
        next: (user) => {
          if (user) {
            this.authClearService.SetLogoutEvent();
          } else {
            this.authService.removeIndexedDbItem().then(() => {
              console.trace();
              //log.error('[reset-login.component.ts] line 31, localStorage clear() called');
              console.log(new Date().toLocaleString() + ' ngOnInit reset login ➤  window.localStorage.clear()');
              window.localStorage.clear();
              this.authService.isSetLoggedOut = true;
              this.router.navigate(['/login']);
            });
          }
        },
        error: (e) => {
          console.log(e);
          console.trace();
          console.log(new Date().toLocaleString() + ' ngOnInit reset login ➤  window.localStorage.clear()');
          window.localStorage.clear();
          this.loaderService.showMain = false;
          window.location.href = '/';
        },
      });
    }
  }
}
